import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ImpersonationService } from '../../_services/impersonation.service';
import { AuthService } from '../../_services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  isImpersonating = false;
  impersonatedUserName = '';
  impersonatedUserRole = '';
  isExiting = false;
  
  private impersonationSubscription?: Subscription;

  constructor(
    private impersonationService: ImpersonationService,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // Subscribe to impersonation state changes
    this.impersonationSubscription = this.impersonationService.isImpersonating$.subscribe(
      isImpersonating => {
        this.isImpersonating = isImpersonating;
        if (isImpersonating) {
          this.impersonatedUserName = this.impersonationService.getImpersonatedUserDisplayName();
          this.impersonatedUserRole = this.impersonationService.getImpersonatedUserRole();
        }
      }
    );
    
    // Check initial state
    this.isImpersonating = this.impersonationService.isImpersonating();
    if (this.isImpersonating) {
      this.impersonatedUserName = this.impersonationService.getImpersonatedUserDisplayName();
      this.impersonatedUserRole = this.impersonationService.getImpersonatedUserRole();
    }
  }

  ngOnDestroy(): void {
    if (this.impersonationSubscription) {
      this.impersonationSubscription.unsubscribe();
    }
  }

  exitImpersonation(): void {
    if (this.isExiting) {
      return;
    }
    
    this.isExiting = true;
    
    this.impersonationService.stopImpersonation().subscribe({
      next: (response) => {
        if (response.success) {
          this.toastr.success('Returned to admin view', 'Impersonation Ended');
          // Navigate to admin home page
          this.router.navigate([this.authService.getHomeUrl()]);
        } else {
          this.toastr.error('Failed to exit impersonation mode', 'Error');
        }
        this.isExiting = false;
      },
      error: (error) => {
        console.error('Error stopping impersonation:', error);
        this.toastr.error('Failed to exit impersonation mode', 'Error');
        this.isExiting = false;
      }
    });
  }
}
